import './service-unavailable.css';

function ServiceUnavailable() {
    function handleRetry() {
        window.location.href = '/login';
    }

    return (
        <section className='service-unavailable'>
            <div className='service-unavailable__card'>
                <p className='service-unavailable__tag'>Bertoli Tours Admin</p>
                <h1>Serviço temporariamente indisponível</h1>
                <p>
                    Não conseguimos conexão com o servidor no momento. Verifique a internet ou aguarde alguns
                    instantes e tente novamente.
                </p>

                <div className='service-unavailable__actions'>
                    <button className='blue-button' type='button' onClick={handleRetry}>
                        Tentar novamente
                    </button>
                </div>
            </div>
        </section>
    );
}

export default ServiceUnavailable;
